import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import FieldIconWrapper from 'common/components/form/FieldIconWrapper';

import TimePicker from 'react-time-picker';

class FieldTimePicker extends PureComponent {
  state = { time: '', initialValue: false };

  componentWillReceiveProps = () => {
    const time = this.props.value;
    if (!this.state.initialValue) {
      this.setState({ time, initialValue: true });
    }
  };

  onChange = (time) => {
    this.setState({ time });
    time = { target: { name: this.props.name, value: time } };
    console.log(time);
    this.props.handleChange(time);
  };

  render = () => (
    <TimePicker
      className="form-control w-100"
      clockClassName="form-control w-100"
      onChange={this.onChange}
      value={this.state.time}
    />
  );
}

const FieldTime = ({
  name = '',
  value = '',
  placeholder,
  autoFocus,
  inputSize,
  isLoading = false,
  handleChange = () => {},
  t,
  ...passThroughProps
}) => (
  <FieldIconWrapper {...passThroughProps} formatDate={'DD/MM/YYYY'}>
    <FieldTimePicker
      name={name}
      value={value}
      placeholder={placeholder}
      autoFocus={autoFocus}
      inputSize={inputSize}
      isLoading={isLoading}
      handleChange={handleChange}
      passThroughProps={passThroughProps}
    />
  </FieldIconWrapper>
);

FieldTime.propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  error: PropTypes.object,
  handleChange: PropTypes.func,
  inputSize: PropTypes.oneOf(['lg', 'sm']),
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRightSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconRightSpin: PropTypes.bool,
  iconLeftSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconLeftSpin: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default translate()(FieldTime);



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldTime.js